export const updateLoading = (isLoading) => {
    console.log("SET LOADING to " + isLoading);
    return {
        type: "UPDATE_LOADING",
        payload: isLoading
    };
};
